function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
export var MissingTranslationError = /*#__PURE__*/function (_Error) {
  _inherits(MissingTranslationError, _Error);
  var _super = _createSuper(MissingTranslationError);
  function MissingTranslationError(key, locale) {
    _classCallCheck(this, MissingTranslationError);
    return _super.call(this, "Missing translation for key: ".concat(key, " in locale: ").concat(locale));
  }
  return MissingTranslationError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var MissingReplacementError = /*#__PURE__*/function (_Error2) {
  _inherits(MissingReplacementError, _Error2);
  var _super2 = _createSuper(MissingReplacementError);
  function MissingReplacementError(replacement) {
    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, MissingReplacementError);
    var errorMessage = '';
    var replacementKeys = Object.keys(replacements);
    if (replacementKeys.length < 1) {
      errorMessage = "No replacement found for key '".concat(replacement, "' (and no replacements were passed in).");
    } else {
      errorMessage = "No replacement found for key '".concat(replacement, "'. The following replacements were passed: ").concat(replacementKeys.map(function (key) {
        return "'".concat(key, "'");
      }).join(', '));
    }
    return _super2.call(this, errorMessage);
  }
  return MissingReplacementError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var MissingCurrencyCodeError = /*#__PURE__*/function (_Error3) {
  _inherits(MissingCurrencyCodeError, _Error3);
  var _super3 = _createSuper(MissingCurrencyCodeError);
  function MissingCurrencyCodeError() {
    var additionalMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    _classCallCheck(this, MissingCurrencyCodeError);
    var baseErrorMessage = 'No currency code provided.';
    return _super3.call(this, additionalMessage === '' ? baseErrorMessage : "".concat(baseErrorMessage, " ").concat(additionalMessage));
  }
  return MissingCurrencyCodeError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var MissingCountryError = /*#__PURE__*/function (_Error4) {
  _inherits(MissingCountryError, _Error4);
  var _super4 = _createSuper(MissingCountryError);
  function MissingCountryError() {
    var additionalMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    _classCallCheck(this, MissingCountryError);
    var baseErrorMessage = 'No country code provided.';
    return _super4.call(this, additionalMessage === '' ? baseErrorMessage : "".concat(baseErrorMessage, " ").concat(additionalMessage));
  }
  return MissingCountryError;
}(/*#__PURE__*/_wrapNativeSuper(Error));